import post from './httpPost';
import get from './httpGet';
import httpDelete from './httpDelete';
import put from './httpPut';

const httpClient = {
  post,
  get,
  delete: httpDelete,
  put
};

export default httpClient;
